import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CuestionariosService } from '../services/cuestionarios.service';

@Component({
  selector: 'app-copiar-cuestionario-dialog',
  templateUrl: './copiar-cuestionario-dialog.component.html'
})
export class CopiarCuestionarioDialogComponent implements OnInit {
  @Output() formResult = new EventEmitter<any>();
  form: FormGroup;
  cuestionarios: any[] = [];
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private cuestionariosService: CuestionariosService
  ) {
    this.form = this.fb.group({
      origen: ['', [Validators.required]],
      destino: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.cargarCuestionarios();
  }

  cargarCuestionarios(): void {
    this.loading = true;
    const request = {
      que: "0",
      tope: "999",
      cmd: "",
      sClave: "",
      sDescripcion: "",
      iTipo: 0,
      iGestion: 0,
      bTodos: 0
    };

    this.cuestionariosService.getCuestionarios(request).subscribe({
      next: (response) => {
        if (response.success) {
          this.cuestionarios = response.data.map((item: any) => ({
            label: `${item.sClaveCues} - ${item.sDescripcion}`,
            value: item.sClaveCues
          }));
        }
      },
      error: (error) => {
        console.error('Error al cargar cuestionarios:', error);
        this.formResult.emit({ 
          refresh: false, 
          success: false, 
          error: 'Error al cargar los cuestionarios' 
        });
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  onSubmit(): void {
    if (this.form.valid) {
      this.loading = true;
      const request = {
        que: 7,
        sClave: this.form.get('origen')?.value,
        sDescripcion: this.form.get('destino')?.value,
        iTipo: 0,
        iGestion: 0,
        bTodos: 0
      };

      this.cuestionariosService.eliminarCuestionario(request).subscribe({
        next: (response) => {
          if (response.success && response.data.error === 0) {
            this.formResult.emit({ 
              refresh: true, 
              success: true,
              message: 'Cuestionario copiado correctamente'
            });
          } else {
            this.formResult.emit({ 
              refresh: false, 
              success: false,
              error: 'Error al copiar el cuestionario'
            });
          }
        },
        error: (error) => {
          console.error('Error al copiar cuestionario:', error);
          this.formResult.emit({ 
            refresh: false, 
            success: false,
            error: 'Error al copiar el cuestionario'
          });
        },
        complete: () => {
          this.loading = false;
        }
      });
    }
  }
} 